import DatWorkedTableHeader from 'components/common/tables_header/day_worked_header';
import { CustomInput } from 'components/custom';
import DayWorkedTable from 'components/tables/day_worked_table';
import { useState } from 'react';
import { totalPerWeek } from 'utils/common_function';
type Props = {
  addData?: (data) => void;
  finalData?: any;
  check?: boolean;
  isSubmit?: boolean;
  messageError?: string;
  setMessageError?: (value: string) => void;
};

const NewWSCalendar = ({
  addData,
  finalData,
  check,
  isSubmit,
  messageError,
  setMessageError,
}: Props) => {
  const [show, setShow] = useState(false);
  // const { getWorkShiftCalendarById } = useMember();
  // const [fetchData, setFetchData] = useState([]);
  // const location = useLocation();

  // useEffect(() => {
  //   if (!isNaN(+location.state?.item?.id))
  //     getWorkShiftCalendarById(location.state?.item.id || id).then((res) => {
  //       if (res) {
  //         setFetchData(res);
  //       }
  //     });
  // }, [location.state?.id, id]);

  return (
    <div style={{ marginTop: '30px' }} className={'tab_children'}>
      <section className={'function_container'}>
        <div style={{ background: 'white' }} className={'function_wrapper'}>
          <h2 className="sub_title_text">Information</h2>
          <div
            style={{
              marginBottom: '20px',
              marginTop: 30,
              display: 'flex',
              gap: 30,
            }}
          >
            {/* <img
              onClick={() => setShow(!show)}
              src="/assets/eng.svg"
              alt="flag"
            /> */}
            <div style={{ width: '23%' }}>
              <CustomInput
                disabled={check}
                background={check ? '#f5f5f5' : ''}
                value={(finalData as any).name}
                required
                height="50px"
                fontSize={12}
                maxLength={40}
                error={messageError !== ''}
                width="100%"
                onChange={(e) => {
                  if (messageError !== '' && setMessageError) {
                    setMessageError('');
                  }
                  addData({ name: e.target.value });
                }}
                title="Name"
              />
              {((isSubmit && finalData?.name?.length < 1) || messageError) && (
                <div
                  style={{
                    fontSize: '10px',
                    color: '#DA0000',
                  }}
                >
                  {messageError}
                </div>
              )}
            </div>
            {/* <img src="/assets/eng.svg" alt="flag" /> */}
            {/* <img
              onClick={() => setShow(!show)}
              src="/icons/flag.svg"
              alt="flag"
              style={{ cursor: 'pointer' }}
            /> */}
            <div style={{ width: '23%' }}>
              <CustomInput
                disabled={check}
                background={check ? '#f5f5f5' : ''}
                value={(finalData as any).comment}
                width="100%"
                height="50px"
                fontSize={12}
                maxLength={40}
                onChange={(e) => addData({ comment: e.target.value })}
                title="Comments"
              />
            </div>

            {/* <img src="/assets/eng.svg" alt="flag" />
            <img
              style={{ cursor: 'pointer' }}
              onClick={() => setShow(!show)}
              src="/icons/flag.svg"
              alt="flag"
            /> */}

            {/* <img
              onClick={() => setShow(!show)}
              style={{ cursor: 'pointer' }}
              src="/icons/flag.svg"
              alt="flag"
            /> */}
          </div>
          <div
            style={{
              marginBottom: '20px',
              marginTop: 30,
              display: 'flex',
              gap: '10px',
            }}
          >
            {show && <img src="/assets/eng.svg" alt="flag" />}

            <div style={{ width: '45%' }}>
              <CustomInput
                disabled={check}
                background={check ? '#f5f5f5' : ''}
                value={(finalData as any).description}
                width="100%"
                height="50px"
                fontSize={12}
                maxLength={40}
                onChange={(e) => addData({ description: e.target.value })}
                title="Description"
              />
            </div>
            <img
              onClick={() => setShow(!show)}
              style={{ cursor: 'pointer' }}
              src="/icons/flag.svg"
              alt="flag"
            />
            {show && (
              <img
                src="/assets/eng.svg"
                style={{ marginLeft: '16px' }}
                alt="flag"
              />
            )}
            <div style={{ width: '45%', marginLeft: show ? '0px' : '60px' }}>
              <CustomInput
                disabled={check}
                background={check ? '#f5f5f5' : ''}
                value={(finalData as any).long_description}
                width="100%"
                height="50px"
                fontSize={12}
                maxLength={40}
                onChange={(e) => addData({ long_description: e.target.value })}
                title="Long Description"
              />
            </div>
            <img
              onClick={() => setShow(!show)}
              style={{ cursor: 'pointer' }}
              src="/icons/flag.svg"
              alt="flag"
            />
          </div>
          {show && (
            <div
              style={{
                marginBottom: '20px',
                marginTop: 30,
                display: 'flex',
                gap: 10,
              }}
            >
              <img src="/icons/france.svg" alt="flag" />
              <div style={{ width: '45%' }}>
                <CustomInput
                  disabled={check}
                  background={check ? '#f5f5f5' : ''}
                  value={(finalData as any).french_description}
                  width="100%"
                  height="50px"
                  fontSize={12}
                  maxLength={40}
                  onChange={(e) =>
                    addData({ french_description: e.target.value })
                  }
                  title="Description"
                />
              </div>
              <img
                onClick={() => setShow(!show)}
                style={{ cursor: 'pointer' }}
                src="/icons/flag.svg"
                alt="flag"
              />
              <img
                src="/icons/france.svg"
                style={{ marginLeft: '16px' }}
                alt="flag"
              />
              <div style={{ width: '45%' }}>
                <CustomInput
                  disabled={check}
                  background={check ? '#f5f5f5' : ''}
                  value={(finalData as any).french_long_description}
                  width="100%"
                  height="50px"
                  fontSize={12}
                  maxLength={40}
                  onChange={(e) =>
                    addData({ french_long_description: e.target.value })
                  }
                  title="Long Description"
                />
              </div>
              <img
                onClick={() => setShow(!show)}
                style={{ cursor: 'pointer' }}
                src="/icons/flag.svg"
                alt="flag"
              />
            </div>
          )}
        </div>
      </section>
      <section
        style={{
          marginTop: 35,
          paddingBottom: 35,
        }}
        className={'function_container'}
      >
        <div
          className={'function_wrapper'}
          style={{
            paddingLeft: 0,
            paddingRight: 0,
          }}
        >
          <h2
            className="sub_title_text"
            style={{
              paddingLeft: 32,
            }}
          >
            Day Worked
          </h2>
          <div
            className="employee_directory_filter_table"
            style={{
              width: '100%',
              marginTop: '30px',
              height: '480px',
              marginBottom: '10px',
              borderRadius: 0,
            }}
          >
            <DatWorkedTableHeader />
            {/* <DayWorkedTable check={true}  finalData={finalData} addData={addData} /> */}
            {/* {/* <DayWorkedTable finalData={fetchData?.length === 0 ? finalData : {workshift_days: (fetchData as any)?.workshift_days}  } addData={addData} /> */}
            <DayWorkedTable
              check={check}
              finalData={finalData}
              addData={addData}
            />

            <div
              className="default_box"
              style={{
                marginTop: 50,
                width: '100%',
              }}
            >
              {/* <div
                style={{ width: '50%', height: 100, display: 'flex', gap: 30 }}
              >
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <span>Minimum hours per day(hh:mm)</span>
                    <TimePicker />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      marginTop: 20,
                    }}
                  >
                    <span>Maximum hours per day(hh:mm)</span>
                    <TimePicker />
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                    }}
                  >
                    <span>Minimum hours per week(hh:mm)</span>
                    <TimePicker />
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 10,
                      marginTop: 20,
                    }}
                  >
                    <span>Maximum hours per week(hh:mm)</span>
                    <TimePicker />
                  </div>
                </div>
              </div> */}
            </div>
          </div>
          <div style={{ marginLeft: '65%', display: 'flex', gap: '15%' }}>
            <span
              style={{
                color: '#000000',
                fontWeight: '600px',
                fontSize: '14px',
              }}
            >
              Per Week
            </span>
            <span
              style={{
                color: '#000000',
                fontWeight: '600px',
                fontSize: '14px',
              }}
            >
              {totalPerWeek(finalData?.workshift_days)}
            </span>
          </div>
          {/* <section style={{ marginTop: 35 }} className={'function_container'}>
            <div className={'function_wrapper'}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 15,
                }}
              >
                <h2 className="sub_title_text">Advanced Settings</h2>
                <span style={{ textDecoration: 'underline', marginBottom: 10 }}>
                  Fewer options
                </span>
              </div>
              <div style={{ display: 'flex', gap: 30, marginTop: 20 }}>
                <div style={{ width: '30%' }}>
                  <h2 className="sub_title_text">Children and Dependents</h2>
                  <div style={{ width: '100%', marginTop: 20 }}>
                    <CustomInput title="Equivalent hours per day during overtime transfer" />
                  </div>
                  <div style={{ color: '#898989', marginTop: 20 }}>
                    Leave input mode in days
                  </div>
                  N/A
                </div>
                <div style={{ width: '30%' }}>
                  <h2 className="sub_title_text">Time Tracking</h2>
                  <div style={{ width: '100%', marginTop: 20 }}>
                    <CustomInput title="Maximum duration of consecutive work" />
                  </div>
                </div>
                <div style={{ width: '30%' }}>
                  <h2 className="sub_title_text">Night Shift</h2>
                  <div
                    style={{ gap: 10, display: 'flex', alignItems: 'center' }}
                  >
                    <input
                      style={{
                        width: 10,
                        height: 10,
                      }}
                      type="checkbox"
                    />
                    <div>Special Management</div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
        </div>
      </section>
    </div>
  );
};

export default NewWSCalendar;
